<div
  class="relative transform overflow-hidden rounded-lg bg-white text-left transition-all w-full dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10 sm:max-w-lg shadow-xl"
>
  @if (listing().saleType === 'homesite') {
    <app-map-listing-popover-homesite
      [listing]="listing()"
      (click)="stateService.selectedListingId.set(this.listing().id)"
      class="grid grid-cols-[2fr_3fr] h-36 w-96 cursor-pointer"
    />
  } @else {
    <app-map-listing-popover-home
      [listing]="listing()"
      (click)="stateService.selectedListingId.set(this.listing().id)"
      class="grid grid-cols-[2fr_3fr] h-36 w-96 cursor-pointer"
    />
  }
</div>
